/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 11:16:31
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 11:21:37
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Cascader/index.tsx
 */
import { Cascader } from 'antd';
import React from 'react';

const _Cascader = (props) => {
  const { children, ...rest } = props;
  return <Cascader {...rest}>{children}</Cascader>;
};
export default _Cascader;
